import { infoNotification, showNotification } from '../Notifications';
import { STATUS } from '../../redux/constants';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { loadAPIVersion } from '../../redux/actions/version';

const VersionCheck = (props) => {
  const { parentComponentStatus } = props;

  const dispatch = useDispatch();
  const version = useSelector((state) => state?.version);
  const [versionNotified, setVersionNotified] = useState(false);

  const pagesToNotCheck = ['/register', '/login', '/reset', '/reset/confirm'];

  useEffect(() => {
    if (!pagesToNotCheck?.some((x) => window.location.href?.includes(x))) {
      dispatch(loadAPIVersion());
    }
  }, []);

  const check = (function () {
    // need a closure to avoid repeated calls
    return function () {
      if (!versionNotified) {
        setVersionNotified(true);
        /*
                We compare the version from backend with the version in user's browser (client side),
                meta.json contains the most recent version pulled by generate-build-version.js
                 */
        fetch('/meta.json')
          .then((response) => response.json())
          .then((meta) => {
            // console.log('meta', meta);
            const currentVersion = meta.version;
            console.log(
              'versions',
              version.version,
              currentVersion,
              version.version == currentVersion,
            );
            if (version.version != currentVersion) {
              console.log(
                `We have a new version - ${version.version}. Clearing cache...`,
              );
              if (caches) {
                caches.keys().then(function (names) {
                  for (let name of names) {
                    console.log(`deleting cached ${name}`);
                    caches.delete(name);
                  }
                });
              }
              showNotification(
                infoNotification({
                  statusCode: 600,
                  message: `We have a new version ${version.version}, please refresh your browser!`,
                }),
              );
            } else {
              console.log(
                `You already have the latest version - ${version.version}. No cache refresh needed.`,
              );
            }
          });
      }
    };
  })();

  if (
    parentComponentStatus == STATUS.LOADED &&
    version.status == STATUS.LOADED
  ) {
    if (!pagesToNotCheck?.some((x) => window.location.href?.includes(x))) {
      window.removeEventListener('focus', onFocus);
      check();
      window.addEventListener('focus', onFocus, { once: true });
    }
  }

  // in case user keeps browser opened for too long without refresh
  function onFocus(event) {
    if (!pagesToNotCheck?.some((x) => window.location.href?.includes(x))) {
      event.stopImmediatePropagation(); // to avoid accumulating
      dispatch(loadAPIVersion());
      //console.log('focus', version);
      check();
    }
  }

  return null;
};

export default VersionCheck;
